import React from 'react';
import './AuthUIScaffold.scss';
import biniyogImage from '../assets/biniyogImage.png';
import biniyogLogo from '../assets/biniyog-logo.png';

interface AuthUIScaffoldProps {
  children?: React.ReactNode;
  rightHead?: React.ReactNode;
}

export const AuthUIScaffold: React.FC<AuthUIScaffoldProps> = (props) => {
  return (
    <div className="wrapper">
      <div className="container">
        <div className="col-left">
          <img src={biniyogLogo} alt="logo" className="mobile-logo" />
          <div className="children-div">{props.children}</div>
        </div>
        <div className="col-right">
          <div style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
            <img src={biniyogImage} alt="bg" className="bg" height="90%" width="90%" />
            <span style={{ fontSize: '14px' }}>আপনার সকল বিনিয়োগের সহজ সমাধান </span>
          </div>
        </div>
      </div>
    </div>
  );
};
